export type PendingSend={accountId:string;rid:string;text:string};
export function createSendHistory(clock:()=>number=Date.now){
 let recent:{accountId:string;rid:string;text:string;at:number}[]=[];
 const prune=()=>{const now=clock();recent=recent.filter(x=>now-x.at<15000)};
 return {
  check(accountId:string,rid:string,text:string,pending:PendingSend[]=[],command=false):'duplicate'|'fast'|null{
   prune();const done=recent.filter(x=>x.accountId===accountId&&x.rid===rid),queued=pending.filter(x=>x.accountId===accountId&&x.rid===rid);
   if(!command&&text.trim()&&[...done,...queued].some(x=>x.text.trim()===text.trim()))return 'duplicate';
   return done.length+queued.length>=5?'fast':null;
  },
  record(accountId:string,rid:string,text:string){prune();recent.push({accountId,rid,text,at:clock()});}
 };
}
